import { CSSProperties, ReactElement } from 'react'

import cn from 'classnames'
import { Link } from 'react-router-dom'

import { Loader } from '@UI/crypto_exchange/desktop/components/common/Loader'

import c from './Button.module.scss'

export interface IButonOptions {
  type?: 'button' | 'submit' | 'reset' | undefined
  link?: string
  children: React.ReactNode
  className?: string
  isLoading?: boolean
  onClick?: () => void
  size?: 'small' | 'medium' | ''
  color?: 'dark' | 'green' | 'red' | 'alternative' | 'delete' | 'check'
  disabled?: boolean
  variant?: 'default' | 'text' | 'outlined' | 'ghost'
  hightlight?: boolean
}
const colorThemes = {
  alternative: {
    color: 'var(--alternative)',
    colorRgb: 'var(--alternative-rgb)',
  },
  delete: {
    color: 'var(--negative-o)',
    colorRgb: 'var(--negative-rgb-o)',
  },
  red: {
    color: 'var(--negative-o)',
    colorRgb: 'var(--negative-rgb-o)',
  },
  check: {
    color: '#14d37c',
    colorRgb: '20,211,124',
  },
}
export const Button = ({
  className = '',
  type = 'button',
  isLoading,
  children,
  link,
  onClick,
  disabled = false,
  size = '',
  color = 'alternative',
  variant = 'default',
  hightlight,
}: IButonOptions) => {
  const colors = (colorThemes as any)[color] ?? colorThemes.alternative
  if (link) {
    return (
      <Link className={`${cn(className, c.button, c[size], c[color])}`} to={link}>
        {children}
      </Link>
    )
  }

  return (
    <button
      className={`${cn(
        c.button,
        c[size],
        c[color],
        (isLoading || disabled) && c.disabled,
        c[variant],
        hightlight && c.hightlight,
        className,
      )}`}
      type={type}
      disabled={isLoading || disabled}
      onClick={onClick}
      style={
        {
          '--btn-color': colors.color,
          '--btn-color-rgb': colors.colorRgb,
        } as CSSProperties
      }
    >
      {!isLoading ? children : <Loader size={size} type={'blocks'} />}
    </button>
  )
}
